// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".plan-subscribing-period[data-v-38917678]{display:flex;justify-content:center}", ""]);
// Exports
module.exports = exports;
